import {
    GET_LIST,
    GET_MANY,
} from 'react-admin';
import queryString from 'query-string';
import { getApiUrlForResource } from '../services/apiUrlResolver';

export const US_STATES_RESOURCE_NAME = "states";

// Helper function to get API URL at request time
const getApiUrl = () => getApiUrlForResource(US_STATES_RESOURCE_NAME);

const providerRequestToHttpRequest = (requestType, requestParams) => {
    switch (requestType) {
        case GET_LIST: 
            return { url: `${getApiUrl()}/${US_STATES_RESOURCE_NAME}` };
        case GET_MANY: {
            const query = {
                filter: JSON.stringify({ id: requestParams.ids }),
            };
            return { url: `${getApiUrl()}/${US_STATES_RESOURCE_NAME}?${queryString.stringify(query)}` };
        }
        default:
            throw new Error(`Unsupported fetch action type for "US_STATES" resource ${requestType}`);
    }
};

const httpResponseToProviderData = (httpResponse, requestType, requestParams) => {
    let { headers, json } = httpResponse;
    switch (requestType) {
        case GET_LIST:
            return {
                data: json.map(usStateItem => usStateItem),
                total: parseInt(headers.get('content-range').split('/').pop()),
            };
        case GET_MANY:
            let usStateIdsToGet = requestParams.ids;
            return {
                data: json.filter(usStateItem => usStateIdsToGet.includes(usStateItem.id))
            };
        default:
            throw new Error(`Unsupported fetch action type ${requestType}`);
    }
};

export default {
    resource: US_STATES_RESOURCE_NAME,
    providerInterface: {
        providerRequestToHttpRequest,
        httpResponseToProviderData
    },
};
